export const CART_ITEMS = "CART_ITEMS";
export const ORDER_TYPE = "ORDER_TYPE";
export const ORDER_TYPE_LIST = "ORDER_TYPE_LIST";
export const EMPTY_CART = "EMPTY_CART";
export const ORDER_PROMO_PRICES = "ORDER_PROMO_PRICES";
export const SHIP_TO = "SHIP_TO";
export const DEFAULT_CART_ID = "DEFAULT_CART_ID";
export const PAYMENT_METHOD_INFO = "PAYMENT_METHOD_INFO";
export const IS_CHECKOUT_FLOW = "IS_CHECKOUT_FLOW";
export const IS_ORDER_FROM_CHECKOUT = "IS_ORDER_FROM_CHECKOUT";
export const SHIP_TO_ORDER_SEARCH = "SHIP_TO_ORDER_SEARCH";
export const SET_DEFAULT_POP = "SET_DEFAULT_POP";
export const SHIP_TO_SITE_ADDRESS_ID = "SHIP_TO_SITE_ADDRESS_ID";
export const DROPSHIP_SHIP_TO = "DROPSHIP_SHIP_TO";
export const SHIP_TO_SITE_ADDRESS_STATE = "SHIP_TO_SITE_ADDRESS_STATE";
export const ORDER_TOTAL_PRICE = "ORDER_TOTAL_PRICE";
export const CURRENCY = "CURRENCY";
export const PAYMENT_DATA = "PAYMENT_DATA";
export const PAYNOW_API_URL = "PAYNOW_API_URL";
export const CUST_PROFILE_ID = "CUST_PROFILE_ID";
export const CUST_PAY_PROFILE_ID = "CUST_PAY_PROFILE_ID";
export const PAYMENT_METHOD = "PAYMENT_METHOD";
export const TAX_URI = "TAX_URI";
export const FREIGHT_AMT = "FREIGHT_AMT";
export const BREADCRUMB = "BREADCRUMB";
export const PAYMENT_PAYLOAD = "PAYMENT_PAYLOAD";
export const SET_UTM_PARAMS = "SET_UTM_PARAMS";
export const UNIQUE_CUST_ID = "UNIQUE_CUST_ID";
export const FREEZE_PERIOD = "FREEZE_PERIOD";
export const OKTA_USERID = "OKTA_USERID";
export const TOTAL_WITH_FREIGHT = "TOTAL_WITH_FREIGHT";

export const DROPSHIP = "Drop Ship";
export const DROP_SHIP = "DROP_SHIP";
export const SET_PRICE_LIST_ID = "SET_PRICE_LIST_ID";
export const QUOTE_PDF_DETAILS = "QUOTE_PDF_DETAILS";
export const DOWNLOAD_MODAL_TYPE = "DOWNLOAD_MODAL_TYPE";

const initialState = {
  cartItems: [],
  orderType: null,
  orderTypeList: null,
  EmptyCartEndpoint: "",
  orderPrices: [],
  shipTo: [],
  isCheckoutFlow: false,
  isOrderFromCheckout: false,
  shipToOrderSearch: false,
  isSetDefaultPop: false,
  shipToSiteAddressID: "",
  dropShipTO: "",
  shipToSiteAddressState: "",
  orderTotalPrice: "",
  currency: "",
  paymentData: "",
  payNowApiUrl: "",
  custProfileDataId: "",
  customerPaymentProfileId: null,
  paymentMethodName: null,
  taxUri: null,
  freightAmount: "",
  breadcrumb: "",
  paymentPayloadGlobal: {},
  uniqueCustId: "",
  utmParams: null,
  defaultCartIDStore: "",
  freezePeriod: null,
  paymentMethodUri: "",
  oktaUserID: '',
  totalWithFreight: '',
  quotePdfInfo: {},
  downloadModalType: ""
};

export default (state = initialState, action) => {
  switch (action?.type) {
    case CART_ITEMS: {
      return {
        ...state,
        cartItems: action?.payload,
      };
    }
    case ORDER_TYPE: {
      return {
        ...state,
        orderType:
          action?.payload === DROPSHIP
            ? DROP_SHIP
            : action?.payload?.toUpperCase(),
      };
    }
    case ORDER_TYPE_LIST: {
      return {
        ...state,
        orderTypeList: action?.payload,
      };
    }
    case EMPTY_CART: {
      return {
        ...state,
        EmptyCartEndpoint: action?.payload,
      };
    }
    case ORDER_PROMO_PRICES: {
      return {
        ...state,
        orderPrices: action?.payload,
      };
    }
    case ORDER_TOTAL_PRICE: {
      return {
        ...state,
        orderTotalPrice: action?.payload,
      };
    }
    case SHIP_TO: {
      return {
        ...state,
        shipTo: action?.payload,
      };
    }
    case DEFAULT_CART_ID: {
      const value = action?.payload?.trim?.();

      const isValid = typeof value === "string" && value;

      isValid
        ? localStorage.setItem("defaultCartId", value)
        : localStorage.removeItem("defaultCartId");

      return {
        ...state,
        defaultCartIDStore: isValid ? value : "",
      };
    }
    case PAYMENT_METHOD_INFO: {
      return {
        ...state,
        paymentMethodUri: action?.payload,
      };
    }
    case IS_CHECKOUT_FLOW: {
      return {
        ...state,
        isCheckoutFlow: action?.payload,
      };
    }
    case IS_ORDER_FROM_CHECKOUT: {
      return {
        ...state,
        isOrderFromCheckout: action?.payload,
      };
    }
    case SHIP_TO_ORDER_SEARCH: {
      return {
        ...state,
        shipToOrderSearch: action?.payload,
      };
    }
    case SET_DEFAULT_POP: {
      return {
        ...state,
        isSetDefaultPop: action?.payload,
      };
    }
    case SHIP_TO_SITE_ADDRESS_ID: {
      return {
        ...state,
        shipToSiteAddressID: action?.payload,
      };
    }
    case SHIP_TO_SITE_ADDRESS_STATE: {
      return {
        ...state,
        shipToSiteAddressState: action?.payload,
      };
    }
    case DROPSHIP_SHIP_TO: {
      return {
        ...state,
        dropShipTO: action?.payload,
      };
    }
    case CURRENCY: {
      return {
        ...state,
        currency: action?.payload,
      };
    }
    case PAYMENT_DATA: {
      return {
        ...state,
        paymentData: action?.payload,
      };
    }
    case PAYNOW_API_URL: {
      return {
        ...state,
        payNowApiUrl: action?.payload,
      };
    }
    case CUST_PROFILE_ID: {
      return {
        ...state,
        custProfileDataId: action?.payload,
      };
    }
    case CUST_PAY_PROFILE_ID: {
      return {
        ...state,
        customerPaymentProfileId: action?.payload,
      };
    }
    case PAYMENT_METHOD: {
      return {
        ...state,
        paymentMethodName: action?.payload,
      };
    }
    case TAX_URI: {
      return {
        ...state,
        taxUri: action?.payload,
      };
    }
    case FREIGHT_AMT: {
      return {
        ...state,
        freightAmount: action?.payload,
      };
    }
    case BREADCRUMB: {
      return {
        ...state,
        breadcrumb: action?.payload,
      };
    }
    case PAYMENT_PAYLOAD: {
      return {
        ...state,
        paymentPayloadGlobal: action?.payload,
      };
    }
    case SET_UTM_PARAMS: {
      return {
        ...state,
        utmParams: action?.payload,
      };
    }
    case UNIQUE_CUST_ID: {
      return {
        ...state,
        uniqueCustId: action?.payload,
      };
    }
    case OKTA_USERID: {
      return {
        ...state,
        oktaUserID: action?.payload,
      };
    }
    case SET_PRICE_LIST_ID: {
      return {
        ...state,
        priceListId: action?.payload,
      };
    }
    case TOTAL_WITH_FREIGHT: {
      return {
        ...state,
        totalWithFreight: action?.payload,
      };
    }
    case FREEZE_PERIOD: {
      return {
        ...state,
        freezePeriod: action?.payload,
      };
    }
    case QUOTE_PDF_DETAILS : {
      return {
        ...state,
        quotePdfInfo: action?.payload,
      };
    }
    case DOWNLOAD_MODAL_TYPE: {
      return {
        ...state,
        downloadModalType: action?.payload,
      };
    }
    default:
      return state;
  }
};

export const headerProductSearch = (loader) => ({
  type: CART_ITEMS,
  loader,
});
